/* eslint object-curly-newline: */
import { connect } from 'react-redux';
import LineChartComponent from './../Components/LineChartComponent.jsx';
import {
  getCaseMetricsScanMetrics,
  getMetricsPageHighlights,
  getCaseMetricsDurationChartPointColors,
  metricPageReducer
} from './../reducers';

import { chart, metrics as metricConstants } from './../helpers';
import { selectJob } from './../actions';
import { colours, CASE_METRICS_TOGGLES } from './../helpers';

/**
 * Filters metrics only for those whose job ran on a node
 * matching nodes described on the SCAN ticket when the
 * filter has been toggled on
 *
 * Duration chart does this filter specifically because performance
 * trends for SCANs must consider the hardware they were ran on
 * to avoid false conclusions with regards to duration deltas.
 *
 * @param {obj} state - the state
 */
export const getFilteredArtifactOnlyMetrics = (state) => {
  const info = metricPageReducer.getMetricsPageInfo(state);
  const showArtifactOnly = (info.toggles & CASE_METRICS_TOGGLES.ARTIFACT_ONLY) ===
    CASE_METRICS_TOGGLES.ARTIFACT_ONLY;
  const metrics = getCaseMetricsScanMetrics(state)
    .filter(m => m && (showArtifactOnly || !m.runnerNodeScanMismatch));
  return metrics;
};

export const mapStateToProps = (state) => {
  const metrics = getFilteredArtifactOnlyMetrics(state);
  const ccfRuntimeData = metrics.map(m => m && m.ccf.runtime ? m.ccf.runtime : 0);
  const ncfRuntimeData = metrics.map(m => m && m.ncf.runtime ? m.ncf.runtime : 0);
  const ccfRuntimeAvg = metricConstants.getRollingAverage(ccfRuntimeData, 0.10);
  const ncfRuntimeAvg = metricConstants.getRollingAverage(ncfRuntimeData, 0.10);
  const pointRadius = metrics ? 0 : 4;
  const highlights = getMetricsPageHighlights(state);
  const pointColors = getCaseMetricsDurationChartPointColors(state);

  return {
    data: [ccfRuntimeData, ccfRuntimeAvg, ncfRuntimeData, ncfRuntimeAvg],
    series: [
      {
        backgroundColor: colours.METRICS_CHARTS.CCF_DEFAULT,
        borderColor: colours.METRICS_CHARTS.CCF_DEFAULT,
        label: 'CCF Total Duration',
        pointRadius
      },
      {
        backgroundColor: colours.METRICS_CHARTS.CCF_DEFAULT,
        borderColor: colours.METRICS_CHARTS.CCF_DEFAULT,
        label: 'CCF Average Total Duration',
        pointRadius,
        borderWidth: 1
      },
      {
        backgroundColor: colours.METRICS_CHARTS.NCF_DEFAULT,
        borderColor: colours.METRICS_CHARTS.NCF_DEFAULT,
        label: 'NCF Total Duration',
        pointRadius
      },
      {
        backgroundColor: colours.METRICS_CHARTS.NCF_DEFAULT,
        borderColor: colours.METRICS_CHARTS.NCF_DEFAULT,
        label: 'NCF Average Total Duration',
        pointRadius,
        borderWidth: 1
      }
    ],
    labels: metrics.map(m => m ? m.jobNumber : undefined),
    pointOptions: chart.caseMetricsPointColorsToOptions(
      pointColors,
      [
        colours.METRICS_CHARTS.CCF_DEFAULT,
        colours.METRICS_CHARTS.CCF_DEFAULT,
        colours.METRICS_CHARTS.NCF_DEFAULT,
        colours.METRICS_CHARTS.NCF_DEFAULT
      ]
    ),
    orphanPointRadius: 4,
    lines: highlights,
    options: {
      scales: { xAxes: [{ offset: true }] },
      tooltips: {
        callbacks: {
          footer: (tooltipItem) => {
            return [chart.metricsJobIdTooltipFooter(tooltipItem)(metrics),
              chart.metricsNotesTooltipFooter()];
          }
        }
      }
    }
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClick: (chart) => dispatch(selectJob(chart))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LineChartComponent);


// WEBPACK FOOTER //
// src/Containers/CaseMetricsDurationChartContainer.jsx